module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ko6Gf"))).then(() => parcelRequire('1iHdE'));